module.exports = __webpack_public_path__ + "static/img/14.1d950269.png";